import React, { useState } from 'react';
import axios from 'axios';
import * as API from "../../Endpoints/endpoint";
import './form.css';

function UploadInfo() {
  const [formData, setFormData] = useState({
    srno: '',
    chartname: '',
    photopdf: '',     
    language: '',
    religion: '',
    avatar: '',
    voice: '',
    vedio: '',
    mood: '',
    agegroup: '',
    term: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(API.POST_QRCODE, formData);
      alert('✅ ' + response.data);
    } catch (error) {
      console.error(error);
      alert('❌ Error uploading data');
    }
  };

  return (
    <div className="upload-container">
      <h2>Upload Chart Info</h2>
      <form onSubmit={handleSubmit}>

        <h3>Chart Details</h3>

        <label>Sr No</label>
        <input type="number" name="srno" placeholder="Enter Serial Number" onChange={handleChange} required />

        <label>Chart Name</label>
        <input type="text" name="chartname" placeholder="Chart Name" onChange={handleChange} required />

        <label>Photo PDF Link</label>
        <input type="text" name="photopdf" placeholder="Enter PDF URL" onChange={handleChange} required />

        <h3>Additional Details</h3>

        <label>Language</label>
        <input type="text" name="language" placeholder="Language" onChange={handleChange} />

        <label>Religion</label>
        <input type="text" name="religion" placeholder="Religion" onChange={handleChange} />

        <label>Avatar</label>
        <input type="text" name="avatar" placeholder="Avatar" onChange={handleChange} />

        <label>Voice</label>
        <input type="text" name="voice" placeholder="Voice" onChange={handleChange} />

        <label>Vedio</label>
        <input type="text" name="vedio" placeholder="Vedio" onChange={handleChange} />

        <label>Mood</label>
        <input type="text" name="mood" placeholder="Mood" onChange={handleChange} />

        <label>Age Group</label>
        <input type="text" name="agegroup" placeholder="Age Group" onChange={handleChange} />

        <label>Term</label>
        <input type="text" name="term" placeholder="Term" onChange={handleChange} />

        <button type="submit">Submit</button>
      </form>
    </div>
  );
}

export default UploadInfo;
